import {
    CANCEL_INTERVIEW_VENDOR_REQUEST,
    CANCEL_INTERVIEW_VENDOR_SUCCESS,
    CANCEL_INTERVIEW_VENDOR_FAIL
  } from "../constants/AuthConstant";
  
  const initialState = {
    loading: false,
    action: "Job Action",
    result: null,
    msg: "",
    error: "",
  };
  
  const CancelInterviewReducer = (state = initialState, action) => {
    switch (action.type) {
      case CANCEL_INTERVIEW_VENDOR_REQUEST:
        return {
          ...state,
          loading: action.payload,
        };
      case CANCEL_INTERVIEW_VENDOR_SUCCESS:
        return {
          ...state,
          result: action.result.data,
          loading: action.payload,
          msg: action.msg,
        };
      case CANCEL_INTERVIEW_VENDOR_FAIL:
        return {
          ...state,
          error: action.error,
          loading: action.payload,
          msg: action.msg,
        };
  
      default:
        return state;
    }
  };
  
  export default CancelInterviewReducer;